import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, catchError, finalize, from, mergeMap, tap, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { LoadingService } from 'src/app/shared/service/loading.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private loadingService: LoadingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {

    return from(this.authService.getToken())
    .pipe(
      mergeMap((token)=>{
        const authRequest = request.clone({
          setHeaders: {
            Authorization: `${token.tokens?.idToken?.toString()}`
          }
        })
        return next.handle(authRequest);
      }),
      tap(() => {
        this.loadingService.setLoading(true, request.url)
      }),
      finalize(() => {
        this.loadingService.setLoading(false, request.url)
      }),
      catchError(err =>{
        return throwError(() => {})
      }),
    )
  }
}
